import { FilterGroup } from '@/service/type/Filter';
import React, { useEffect, useRef, useState } from 'react';
import FilterCard from './FilterCard';
import { FilterGroupListResponse } from '@/service/filter';

const FilterCards: React.FC<{ getStyleFilterGroupData?: FilterGroupListResponse }> = ({ getStyleFilterGroupData }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const CARD_WIDTH = 300;
  const CARDS_GAP = 16;

  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  const checkScrollPosition = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;

      setIsAtStart(scrollLeft <= 0);
      setIsAtEnd(Math.abs(scrollWidth - clientWidth - scrollLeft) < 1);
    }
  };

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener('scroll', checkScrollPosition);
      return () => {
        container.removeEventListener('scroll', checkScrollPosition);
      };
    }
  }, []);

  useEffect(() => {
    checkScrollPosition();
  }, [getStyleFilterGroupData]);

  const handleScroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollAmount = CARD_WIDTH + CARDS_GAP;
      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;

      if (direction === 'right' && isAtEnd) {
        container.scrollTo({
          left: 0,
          behavior: 'smooth',
        });
      } else if (direction === 'left' && isAtStart) {
        container.scrollTo({
          left: scrollWidth - clientWidth,
          behavior: 'smooth',
        });
      } else {
        const newScrollPosition = scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
        container.scrollTo({
          left: newScrollPosition,
          behavior: 'smooth',
        });
      }
    }
  };

  return (
    <div className="flex flex-col relative">
      <div className="flex justify-between pt-6 pb-4 pr-32">
        <div className="text-[#111112] text-[1.25rem] font-normal leading-[20px] tracking-[-0.32px]">Featured StyleFilters™</div>
        <div className="flex justify-end gap-2 z-10">
          <button
            onClick={() => handleScroll('left')}
            className="bg-[#eaeaeb] hover:bg-[#d1d1d1] rounded-full p-2 transition-colors"
            disabled={isAtStart}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke={isAtStart ? '#9D9DA6' : 'currentColor'}
              strokeWidth="2"
            >
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
          <button
            onClick={() => handleScroll('right')}
            className="bg-[#eaeaeb] hover:bg-[#d1d1d1] rounded-full p-2 transition-colors"
            disabled={isAtEnd}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke={isAtEnd ? '#9D9DA6' : 'currentColor'}
              strokeWidth="2"
            >
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
        </div>
      </div>

      <div ref={scrollContainerRef} className="flex overflow-x-auto gap-4 scroll-smooth hide-scrollbar">
        {getStyleFilterGroupData?.data
          ?.filter((item) => item.artist)
          ?.map((item: FilterGroup) => {
            return <FilterCard key={item.id} data={item} className="w-[278px] h-fit" />;
          })}
      </div>
    </div>
  );
};

export default FilterCards;
